import { faDigits } from "../i18n/digits";
import { fa } from "../i18n/fa";

/**
 * The positional label a پاسور / بلوف seat falls back to when no real person is known for it —
 * the `fallback` half of {@link resolveSeatName}.
 *
 * ⚠️ IT LIVES IN ITS OWN MODULE FOR THE REASON `hearts-seat-label.ts` DOES: the felt and the
 * end-of-match card must name the same chair identically, and until 2026-08-30 they did not even
 * agree on the DIGITS — the felt said «بازیکن ۲» and the card said «بازیکن 2», because each had
 * grown its own copy. Importing the screen module from the game container to share this would
 * couple them (and break every test that mocks the table), so the one implementation sits here,
 * where both surfaces can reach it.
 *
 * ⚠️ The number is the ABSOLUTE SEAT INDEX, deliberately unchanged: this is a MOVE of what the
 * felt already renders, not a redesign. It is why seat 0 reads «بازیکن ۰» — worth fixing one day
 * (see {@link botOrdinal}, which solved exactly this for حکم / بی‌دل / شلم), but changing it here
 * would silently restyle the felt too.
 */
export function pasurSeatFallback(seat: number): string {
  return `${fa.pasur.opponent} ${faDigits(seat)}`;
}

/**
 * پاسور's two SIDES as the viewer names them, on the felt and on the end card alike: «ما» / «حریف» —
 * two partnerships — at four seats; at TWO seats the viewer is one player, so «شما» / «حریف», the
 * words every table for two uses (دوز's score box, تخته نرد's «شما … حریف»; operator, 2026-10-20).
 * «شما» is the viewer's own seat name (`fa.pasur.you`), the same person under the same word.
 */
export function pasurSideWords(seats: number): { readonly us: string; readonly them: string } {
  return { us: seats === 2 ? fa.pasur.you : fa.pasur.us, them: fa.pasur.them };
}

/** بلوف's positional label — the same shape as {@link pasurSeatFallback}, its own word. */
export function bluffSeatFallback(seat: number): string {
  return `${fa.bluff.opponent} ${faDigits(seat)}`;
}
